import styled from '@emotion/styled';

import { fontWeight } from '~/styles';

export const Container = styled.div`
  font-weight: ${fontWeight.medium};
  font-size: 14px;
  display: flex;
  gap: 10px;
`;
